import { useEffect, useState } from 'react';
import { useSubstate } from 'use-substate';

import { client, useErrorNotifications } from 'core/http';
import { SetCustomerProducts } from 'core/Store/customerProducts/actions';
import { selectCustomerProductsById } from 'core/Store/customerProducts/selectors';
import { Product } from 'core/types/product';

export default function useCustomerProducts(customerId: number) {
  const showErrorNotification = useErrorNotifications();
  const [products, dispatch] = useSubstate(
    selectCustomerProductsById(customerId)
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!customerId) return;

    setLoading(true);

    client()
      .get<Array<Product & { pivot: { price: number } }>>(
        `customers/${customerId}/products`
      )
      .then(response => response.data)
      .then(products => dispatch(new SetCustomerProducts(customerId, products)))
      .catch(showErrorNotification)
      .finally(() => setLoading(false));
  }, [customerId, dispatch, showErrorNotification]);

  return { products, loading };
}
